// Shared brand colors for all background components
export const BRAND_COLORS = {
    primary: '#3315e8',
    secondary: '#3d68ff',
    background: '#F7FAFC'
};
